// src/pages/CodeInput.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { db } from '../firebase'; // Firebase bağlantınızın doğru olduğundan emin olun
import { ref, get } from 'firebase/database'; // Firebase modüllerini import edin

export default function CodeInput() {
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Prefill email if coming from registration
  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
    }
  }, [location.state]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      setError('Please enter your email.');
      return;
    }

    try {
      const emailKey = email.replace('.', '_');
      const snapshot = await get(ref(db, `students/${emailKey}`));

      if (snapshot.exists()) {
        const userData = snapshot.val();
        const accessCode = userData.accessCode; // Firebase'den kaydedilen kodu çek

        // **YENİ ÖZELLİK: Kod kontrolüne göre yönlendirme**
        if (accessCode === 'EDU123') {
          // Eğer kod EDU123 ise Eğitim Dashboard'una yönlendir
          navigate(`/sura-dashboard/${emailKey}`);
        } else {
          // Varsayılan olarak (ABCDE veya başka bir kariyer kodu) Kariyer Dashboard'una yönlendir
          navigate(`/dashboard/${emailKey}`);
        }
      } else {
        setError('Email not found. Please sign up.');
      }
    } catch (err) {
      console.error(err);
      setError('Failed to check email. Try again.');
    }
  };

  return (
    <div className='min-h-screen bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100 flex items-center justify-center px-4'>
      <form
        onSubmit={handleLogin}
        className='w-full max-w-md bg-white shadow-xl rounded-xl p-8 space-y-6'
      >
        <h2 className='text-3xl font-extrabold text-center text-indigo-700 mb-4'>
          Login
        </h2>

        <input
          type='email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder='Email'
          className='w-full rounded-lg border px-4 py-3'
        />

        {error && <p className='text-red-600 text-center'>{error}</p>}

        <button
          type='submit'
          className='w-full bg-indigo-600 text-white py-3 rounded-lg hover:bg-indigo-700 transition'
        >
          Login
        </button>

        {error && error.includes('sign up') && (
          // Mevcut butonu koruyorum: '/register/ABCDE' yerine genel '/register' kullanmak daha esnek olabilir,
          // ancak orijinal isteğinizdeki '/register/ABCDE' rotasını koruyorum.
          <button
            type='button'
            onClick={() => navigate('/register/ABCDE', { state: { email } })}
            className='w-full bg-yellow-400 text-gray-900 py-3 rounded-lg mt-2 hover:bg-yellow-300 transition'
          >
            Sign Up
          </button>
        )}
      </form>
    </div>
  );
}
